(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filters-collection-accordion"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__filterByCollectionHandlerAttached) return;
    window.__filterByCollectionHandlerAttached = true;

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-filter-collection-link]');
      if (!link) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.defaultPrevented) return;

      event.preventDefault();
      const targetUrl = new URL(link.href, window.location.origin);
      const currentSearch = window.location.search;
      if (currentSearch && currentSearch !== '?') {
        targetUrl.search = currentSearch;
      }
      const href = targetUrl.toString();
      const facetsForm = link.closest('facets-form-component') || document.querySelector('facets-form-component');

      if (facetsForm && typeof facetsForm.updateFiltersByURL === 'function') {
        facetsForm.updateFiltersByURL(href);
      } else {
        window.location.assign(href);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
